import * as Types from '../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TestRbsCurrentUserQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TestRbsCurrentUserQuery = {
    __typename?: 'Query';
    currentUser?:
        | {
              __typename?: 'CurrentUserPayload';
              account?:
                  | {
                        __typename?: 'PassportAccount';
                        id: string;
                        accountId: any;
                        accountProfile?:
                            | {
                                  __typename?: 'AccountProfile';
                                  email?:
                                      | { __typename?: 'Email'; emailAddress: any }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type TestRbsGetResumesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TestRbsGetResumesQuery = {
    __typename?: 'Query';
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | {
                        __typename?: 'JobSeekerProfile';
                        resume: Array<{
                            __typename?: 'JobSeekerProfileResume';
                            id: string;
                            resumeType?: Types.JobSeekerProfileResumeType | null | undefined;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type TestRbsCreateEmptyResumeMutationVariables = Types.Exact<{
    input: Types.CreateEmptyJobSeekerProfileResumeInput;
}>;

export type TestRbsCreateEmptyResumeMutation = {
    __typename?: 'Mutation';
    createEmptyJobSeekerProfileResume?:
        | {
              __typename?: 'CreateEmptyJobSeekerProfileResumePayload';
              resume?: { __typename?: 'JobSeekerProfileResume'; id: string } | null | undefined;
          }
        | null
        | undefined;
};

export type TestRbsUpdateResumeMutationVariables = Types.Exact<{
    input: Types.UpdateJobSeekerProfileResumeInput;
}>;

export type TestRbsUpdateResumeMutation = {
    __typename?: 'Mutation';
    updateJobSeekerProfileResume?:
        | {
              __typename?: 'UpdateJobSeekerProfileResumePayload';
              resume?:
                  | {
                        __typename?: 'JobSeekerProfileResume';
                        id: string;
                        firstName?: string | null | undefined;
                        lastName?: string | null | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type TestRbsAddWorkExperiencesMutationVariables = Types.Exact<{
    input: Types.AddJobSeekerProfileResumeWorkExperiencesInput;
}>;

export type TestRbsAddWorkExperiencesMutation = {
    __typename?: 'Mutation';
    addJobSeekerProfileResumeWorkExperiences?:
        | {
              __typename?: 'AddJobSeekerProfileResumeWorkExperiencesPayload';
              workExperiences: Array<{
                  __typename?: 'JobSeekerProfileWorkExperience';
                  id: string;
                  company?: string | null | undefined;
                  title?: string | null | undefined;
              }>;
          }
        | null
        | undefined;
};

export type TestRbsUpdateAutoApplyMutationVariables = Types.Exact<{
    input: Types.UpdateAutoApplyInput;
}>;

export type TestRbsUpdateAutoApplyMutation = {
    __typename?: 'Mutation';
    updateAutoApply: {
        __typename?: 'UpdateAutoApplyPayload';
        autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
        selectedResumeType?: Types.SelectedResumeType | null | undefined;
        mode?: Types.AutoApplyMode | null | undefined;
        sqPastAnswerPrefillPreference?: Types.SqPastAnswerPrefillPreference | null | undefined;
    };
};

export type TestRbsAutoApplyInfoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TestRbsAutoApplyInfoQuery = {
    __typename?: 'Query';
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
              mode?: Types.AutoApplyMode | null | undefined;
              sqPastAnswerPrefillPreference?:
                  | Types.SqPastAnswerPrefillPreference
                  | null
                  | undefined;
              applicantInfo?:
                  | {
                        __typename?: 'ApplicantInfo';
                        ctk?: string | null | undefined;
                        ip?: string | null | undefined;
                        locale?: any | null | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export const TestRbsCurrentUserDocument = gql`
    query TestRbsCurrentUser {
        currentUser {
            account {
                ... on PassportAccount {
                    accountProfile {
                        email {
                            emailAddress
                        }
                    }
                    id
                    accountId
                }
            }
        }
    }
`;

/**
 * __useTestRbsCurrentUserQuery__
 *
 * To run a query within a React component, call `useTestRbsCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestRbsCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestRbsCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestRbsCurrentUserQuery(
    baseOptions?: Apollo.QueryHookOptions<
        TestRbsCurrentUserQuery,
        TestRbsCurrentUserQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<TestRbsCurrentUserQuery, TestRbsCurrentUserQueryVariables>(
        TestRbsCurrentUserDocument,
        options,
    );
}
export function useTestRbsCurrentUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestRbsCurrentUserQuery,
        TestRbsCurrentUserQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<TestRbsCurrentUserQuery, TestRbsCurrentUserQueryVariables>(
        TestRbsCurrentUserDocument,
        options,
    );
}
export function useTestRbsCurrentUserSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              TestRbsCurrentUserQuery,
              TestRbsCurrentUserQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<TestRbsCurrentUserQuery, TestRbsCurrentUserQueryVariables>(
        TestRbsCurrentUserDocument,
        options,
    );
}
export type TestRbsCurrentUserQueryHookResult = ReturnType<typeof useTestRbsCurrentUserQuery>;
export type TestRbsCurrentUserLazyQueryHookResult = ReturnType<
    typeof useTestRbsCurrentUserLazyQuery
>;
export type TestRbsCurrentUserSuspenseQueryHookResult = ReturnType<
    typeof useTestRbsCurrentUserSuspenseQuery
>;
export type TestRbsCurrentUserQueryResult = Apollo.QueryResult<
    TestRbsCurrentUserQuery,
    TestRbsCurrentUserQueryVariables
>;
export const TestRbsGetResumesDocument = gql`
    query TestRbsGetResumes {
        jobSeekerProfile {
            profile {
                resume {
                    id
                    resumeType
                }
            }
        }
    }
`;

/**
 * __useTestRbsGetResumesQuery__
 *
 * To run a query within a React component, call `useTestRbsGetResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestRbsGetResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestRbsGetResumesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestRbsGetResumesQuery(
    baseOptions?: Apollo.QueryHookOptions<TestRbsGetResumesQuery, TestRbsGetResumesQueryVariables>,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<TestRbsGetResumesQuery, TestRbsGetResumesQueryVariables>(
        TestRbsGetResumesDocument,
        options,
    );
}
export function useTestRbsGetResumesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestRbsGetResumesQuery,
        TestRbsGetResumesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<TestRbsGetResumesQuery, TestRbsGetResumesQueryVariables>(
        TestRbsGetResumesDocument,
        options,
    );
}
export function useTestRbsGetResumesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<TestRbsGetResumesQuery, TestRbsGetResumesQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<TestRbsGetResumesQuery, TestRbsGetResumesQueryVariables>(
        TestRbsGetResumesDocument,
        options,
    );
}
export type TestRbsGetResumesQueryHookResult = ReturnType<typeof useTestRbsGetResumesQuery>;
export type TestRbsGetResumesLazyQueryHookResult = ReturnType<typeof useTestRbsGetResumesLazyQuery>;
export type TestRbsGetResumesSuspenseQueryHookResult = ReturnType<
    typeof useTestRbsGetResumesSuspenseQuery
>;
export type TestRbsGetResumesQueryResult = Apollo.QueryResult<
    TestRbsGetResumesQuery,
    TestRbsGetResumesQueryVariables
>;
export const TestRbsCreateEmptyResumeDocument = gql`
    mutation TestRbsCreateEmptyResume($input: CreateEmptyJobSeekerProfileResumeInput!) {
        createEmptyJobSeekerProfileResume(input: $input) {
            resume {
                id
            }
        }
    }
`;
export type TestRbsCreateEmptyResumeMutationFn = Apollo.MutationFunction<
    TestRbsCreateEmptyResumeMutation,
    TestRbsCreateEmptyResumeMutationVariables
>;

/**
 * __useTestRbsCreateEmptyResumeMutation__
 *
 * To run a mutation, you first call `useTestRbsCreateEmptyResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestRbsCreateEmptyResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testRbsCreateEmptyResumeMutation, { data, loading, error }] = useTestRbsCreateEmptyResumeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestRbsCreateEmptyResumeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TestRbsCreateEmptyResumeMutation,
        TestRbsCreateEmptyResumeMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        TestRbsCreateEmptyResumeMutation,
        TestRbsCreateEmptyResumeMutationVariables
    >(TestRbsCreateEmptyResumeDocument, options);
}
export type TestRbsCreateEmptyResumeMutationHookResult = ReturnType<
    typeof useTestRbsCreateEmptyResumeMutation
>;
export type TestRbsCreateEmptyResumeMutationResult =
    Apollo.MutationResult<TestRbsCreateEmptyResumeMutation>;
export type TestRbsCreateEmptyResumeMutationOptions = Apollo.BaseMutationOptions<
    TestRbsCreateEmptyResumeMutation,
    TestRbsCreateEmptyResumeMutationVariables
>;
export const TestRbsUpdateResumeDocument = gql`
    mutation TestRbsUpdateResume($input: UpdateJobSeekerProfileResumeInput!) {
        updateJobSeekerProfileResume(input: $input) {
            resume {
                id
                firstName
                lastName
            }
        }
    }
`;
export type TestRbsUpdateResumeMutationFn = Apollo.MutationFunction<
    TestRbsUpdateResumeMutation,
    TestRbsUpdateResumeMutationVariables
>;

/**
 * __useTestRbsUpdateResumeMutation__
 *
 * To run a mutation, you first call `useTestRbsUpdateResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestRbsUpdateResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testRbsUpdateResumeMutation, { data, loading, error }] = useTestRbsUpdateResumeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestRbsUpdateResumeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TestRbsUpdateResumeMutation,
        TestRbsUpdateResumeMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<TestRbsUpdateResumeMutation, TestRbsUpdateResumeMutationVariables>(
        TestRbsUpdateResumeDocument,
        options,
    );
}
export type TestRbsUpdateResumeMutationHookResult = ReturnType<
    typeof useTestRbsUpdateResumeMutation
>;
export type TestRbsUpdateResumeMutationResult = Apollo.MutationResult<TestRbsUpdateResumeMutation>;
export type TestRbsUpdateResumeMutationOptions = Apollo.BaseMutationOptions<
    TestRbsUpdateResumeMutation,
    TestRbsUpdateResumeMutationVariables
>;
export const TestRbsAddWorkExperiencesDocument = gql`
    mutation TestRbsAddWorkExperiences($input: AddJobSeekerProfileResumeWorkExperiencesInput!) {
        addJobSeekerProfileResumeWorkExperiences(input: $input) {
            workExperiences {
                id
                company
                title
            }
        }
    }
`;
export type TestRbsAddWorkExperiencesMutationFn = Apollo.MutationFunction<
    TestRbsAddWorkExperiencesMutation,
    TestRbsAddWorkExperiencesMutationVariables
>;

/**
 * __useTestRbsAddWorkExperiencesMutation__
 *
 * To run a mutation, you first call `useTestRbsAddWorkExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestRbsAddWorkExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testRbsAddWorkExperiencesMutation, { data, loading, error }] = useTestRbsAddWorkExperiencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestRbsAddWorkExperiencesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TestRbsAddWorkExperiencesMutation,
        TestRbsAddWorkExperiencesMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        TestRbsAddWorkExperiencesMutation,
        TestRbsAddWorkExperiencesMutationVariables
    >(TestRbsAddWorkExperiencesDocument, options);
}
export type TestRbsAddWorkExperiencesMutationHookResult = ReturnType<
    typeof useTestRbsAddWorkExperiencesMutation
>;
export type TestRbsAddWorkExperiencesMutationResult =
    Apollo.MutationResult<TestRbsAddWorkExperiencesMutation>;
export type TestRbsAddWorkExperiencesMutationOptions = Apollo.BaseMutationOptions<
    TestRbsAddWorkExperiencesMutation,
    TestRbsAddWorkExperiencesMutationVariables
>;
export const TestRbsUpdateAutoApplyDocument = gql`
    mutation TestRbsUpdateAutoApply($input: UpdateAutoApplyInput!) {
        updateAutoApply(input: $input) {
            autoApplyStatus
            selectedResumeType
            mode
            sqPastAnswerPrefillPreference
        }
    }
`;
export type TestRbsUpdateAutoApplyMutationFn = Apollo.MutationFunction<
    TestRbsUpdateAutoApplyMutation,
    TestRbsUpdateAutoApplyMutationVariables
>;

/**
 * __useTestRbsUpdateAutoApplyMutation__
 *
 * To run a mutation, you first call `useTestRbsUpdateAutoApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestRbsUpdateAutoApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testRbsUpdateAutoApplyMutation, { data, loading, error }] = useTestRbsUpdateAutoApplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestRbsUpdateAutoApplyMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TestRbsUpdateAutoApplyMutation,
        TestRbsUpdateAutoApplyMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        TestRbsUpdateAutoApplyMutation,
        TestRbsUpdateAutoApplyMutationVariables
    >(TestRbsUpdateAutoApplyDocument, options);
}
export type TestRbsUpdateAutoApplyMutationHookResult = ReturnType<
    typeof useTestRbsUpdateAutoApplyMutation
>;
export type TestRbsUpdateAutoApplyMutationResult =
    Apollo.MutationResult<TestRbsUpdateAutoApplyMutation>;
export type TestRbsUpdateAutoApplyMutationOptions = Apollo.BaseMutationOptions<
    TestRbsUpdateAutoApplyMutation,
    TestRbsUpdateAutoApplyMutationVariables
>;
export const TestRbsAutoApplyInfoDocument = gql`
    query TestRbsAutoApplyInfo {
        autoApplyInfo {
            autoApplyStatus
            mode
            sqPastAnswerPrefillPreference
            applicantInfo {
                ctk
                ip
                locale
            }
        }
    }
`;

/**
 * __useTestRbsAutoApplyInfoQuery__
 *
 * To run a query within a React component, call `useTestRbsAutoApplyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestRbsAutoApplyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestRbsAutoApplyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestRbsAutoApplyInfoQuery(
    baseOptions?: Apollo.QueryHookOptions<
        TestRbsAutoApplyInfoQuery,
        TestRbsAutoApplyInfoQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<TestRbsAutoApplyInfoQuery, TestRbsAutoApplyInfoQueryVariables>(
        TestRbsAutoApplyInfoDocument,
        options,
    );
}
export function useTestRbsAutoApplyInfoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestRbsAutoApplyInfoQuery,
        TestRbsAutoApplyInfoQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<TestRbsAutoApplyInfoQuery, TestRbsAutoApplyInfoQueryVariables>(
        TestRbsAutoApplyInfoDocument,
        options,
    );
}
export function useTestRbsAutoApplyInfoSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              TestRbsAutoApplyInfoQuery,
              TestRbsAutoApplyInfoQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<TestRbsAutoApplyInfoQuery, TestRbsAutoApplyInfoQueryVariables>(
        TestRbsAutoApplyInfoDocument,
        options,
    );
}
export type TestRbsAutoApplyInfoQueryHookResult = ReturnType<typeof useTestRbsAutoApplyInfoQuery>;
export type TestRbsAutoApplyInfoLazyQueryHookResult = ReturnType<
    typeof useTestRbsAutoApplyInfoLazyQuery
>;
export type TestRbsAutoApplyInfoSuspenseQueryHookResult = ReturnType<
    typeof useTestRbsAutoApplyInfoSuspenseQuery
>;
export type TestRbsAutoApplyInfoQueryResult = Apollo.QueryResult<
    TestRbsAutoApplyInfoQuery,
    TestRbsAutoApplyInfoQueryVariables
>;
